module.exports = __webpack_public_path__ + "img/Popup_Bevoelkerung2.0a82aca3.png";